import { useFormik } from "formik";
import React, { useEffect } from "react";
import * as Yup from "yup";
import { useState } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import TextInput from "../../common/textfield/TextInput";
import TextArea from "../../common/textfield/TextArea";
import { usePatientsBySOPQuery } from "../../../hooks/ReactQueryHooks/usePatientsBySOPQuery";
import { useScheduleCategoryQuery } from "../../../hooks/ReactQueryHooks/useScheduleCategoryQuery";
import SelectFiled from "../../common/textfield/SelectFiled";
import { decryptData } from "../../EncryptDecrypt";
import { Button } from "../../common/Button";
import { CircularProgress, Skeleton } from "@mui/material";
import { PickersDay } from '@mui/x-date-pickers/PickersDay';
import { DateSelectorWithoutFormik } from "../../common/textfield/DateSelector";
import moment from "moment";
import { bookAppointment, checkSchedule, getSlots, updateAppointmentRequest, getlistPractitioners } from "../api/AppointmentRequests";
import {getScheduleSlots} from "../../api/Schedule";
import { failed, success } from "../../common/Toastify";
import "./style.css"
import { generatePass } from "./Constants";
import { LOCATIONS } from '../../common/location';
import { useSelector } from "react-redux";
import { getSignature } from "../../Zoom/functions";
import { Form } from "react-bootstrap";
//import { getSingleUser } from "../../api/Individual";
import { useNavigate } from "react-router-dom";
import { editQuestionnaireResponse } from "../../api/Questionnaire";
import { buildSessionTopic } from "../../../utils/ZoomSessionSupport";
import { validation, conditionalValidation } from "../../../utils/constants";

const BookAppointment = ({ modalShow, handleShow = () => {}, type, formikInBoundCall, questionnaireResponseId, encounterIdFromModal, onHide}) => {
    const user = useSelector((state) => state?.auth?.user);
    const [patientsList, setPatientsList] = useState([]);
    const [btnLoading, setBtnLoading] = useState(false);
    const [slotsLoading, setSlotsLoading] = useState(false);
    const [selectedSlot, setSelectedSlot] = useState("");
    const [reservedCategories, setReservedCategories] = useState ({})
    const [serviceCategory, setServiceCategory] = useState([]);
    const [categoriesByDay, setCategoriesByDay] = useState({});
    const [availableSlots, setAvailableSlots] = useState([]);
    const [availableDays, setAvailableDays] = useState([]);
    const [practitionerList, setPractitionerList] = useState([]);
    const [practitionerId, setPractitionerId] = useState( modalShow?.id );
    const [slotUnavailable, setSlotUnavailable] = useState(false);
    const [scopeOfPractice, setScopeOfPractice] = useState(null);
    const [fetchedSchedules, setFetchedSchedules] = useState([]);
    const [computedServiceCategories, setComputedServiceCategories] = useState([]);
    const userOrg = useSelector((state) => state?.auth?.user?.organizations)
    const userOrgId = userOrg?.[0]?.id;

    const navigate = useNavigate()
    const isTagPresent = (tagValue) => formikInBoundCall?.values?.questionResponse?.some(item => item.tag === tagValue);
    const taggedQuestions = formikInBoundCall?.values?.questionResponse;
    const getValueQuestionnair = (tagValue) => formikInBoundCall?.values?.questionResponse?.find(item => item.tag === tagValue)?.answer?.[0]?.answer
    const getValueQuestionnairDropDown = (tagValue) => formikInBoundCall?.values?.questionResponse.find((obj)=> obj?.tag === tagValue)?.answer?.find((val)=>val?.answer !== "")?.answer
    const getValueQuestionnairRadio = (tagValue) => formikInBoundCall?.values?.questionResponse.find((obj)=> obj?.tag === tagValue)?.answer?.find((val)=>val?.answer === true)?.option
    const getRadiOptions = (tagValue) => formikInBoundCall?.values?.questionResponse.find((obj)=> obj?.tag === tagValue)?.answer
    const getValueQuestionnairExt = (tagValue) => formikInBoundCall?.values?.questionResponse?.find(item => item.tag === tagValue)?.answer?.[0]?.answer?.split("ext ")[1]
    const onSuccess = (data) => {
        setPatientsList(data?.map((org) => (org = { value: `{"id": "${org?.id}", "location": "${org?.address[0]?.state}"}`, name: decryptData(org?.name?.[0]?.text?.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')), id: org.id })));
    };

    const { isLoading, } = usePatientsBySOPQuery({ onSuccess, practitioner_id: modalShow?.id, org_id: modalShow?.managingOrganization?.[0]?.reference?.split('/')?.[1] })
    const formik = useFormik({
        initialValues: {
            title: "",
            patient: "",
            date: "",
            serviceCategory: "",
            availableSlot: "",
            preferredChannel: "",
            returnTelephoneNumber: "",
            returnTelephoneNumberExt: "",
            practitionerPreference: modalShow?.id ? "select practitioner" : "",
            practitioner: modalShow?.id ? modalShow?.id : ""
        },
        validationSchema: Yup.object({
            title: conditionalValidation(
                Yup.string(),
                {
                    validation,
                    mandatory: true,
                    label: "Reason for Visit"
                }),
            patient: conditionalValidation(
                Yup.string(),
                {
                    validation,
                    mandatory: true,
                    label: "Patient"
                }),
            date: conditionalValidation(
                Yup.string(),
                {
                    validation,
                    label: "Date",
                    mandatory: true
                }),
            serviceCategory: conditionalValidation(
                Yup.string(),
                {
                    validation,
                    label: "Appointment Type",
                    mandatory: true
                }),
            availableSlot: Yup.object().required("Required slots field."),
            preferredChannel: conditionalValidation(
                Yup.string(),
                {
                    validation,
                    label: "Preferred channel",
                    mandatory: true
                }),
            returnTelephoneNumber: conditionalValidation(
                Yup.string().matches(/^(?:\+?1[-. ]?)?\(?[0-9]\d{2}\)?[-. ]?\d{3}[-. ]?\d{4}$/, "Enter Valid Return Telephone Number."),
                {
                    validation,
                    label: "Return Telephone Number",
                    mandatory: true
                }),
            returnTelephoneNumberExt: conditionalValidation(
                Yup.string().matches(/^\d{0,4}$/, 'Must be 4 digit or less.'),
                {
                    validation,
                    label: "Extension"
                }),
            practitionerPreference: conditionalValidation(
                type === "patient" ? Yup.string().required("Required Practitioner Preference field.") : null,
                {
                    validation,
                    label: "Practitioner Preference"
                }),
            practitioner: type === "patient" ?  Yup.mixed().when(["practitionerPreference"], {
                is: (practitionerPreference) => practitionerPreference !== "no preference",
                then: Yup.string().required("Required Practitioner field."),
                otherwise: Yup.mixed().notRequired(),
            }) : null,
        }),
        onSubmit: (values) => {
            values.title = values.title?.trim();
            setBtnLoading(true);
            let slot = null;
            let utcStart = values?.availableSlot?.start;
            let utcEnd = values?.availableSlot?.end;
            let reserved = values?.availableSlot?.status == "busy-reserved"
            let selectedServiceCategory = values?.serviceCategory;
            // if(selectedServiceCategory.endsWith("busyReserved")){
            //     selectedServiceCategory = selectedServiceCategory.split("-")?.[0];
            // }

            // this filter returns an object as a REFERENCE, so you need to structuredClone the resulting value if there is one
            selectedServiceCategory = serviceCategory?.filter((categoryData) => categoryData.value === selectedServiceCategory)?.[0]
            if(reserved) {
                selectedServiceCategory = structuredClone(selectedServiceCategory);
                selectedServiceCategory.id = selectedServiceCategory?.value?.split("-")[0];
                selectedServiceCategory.name = selectedServiceCategory.name.trim();
            }

            let serviceCategoryPayload = [
                {
                  coding: [
                    {
                      system: "http://florizel.com/AppointmentServiceCategory",
                      code: selectedServiceCategory?.id,
                      display: selectedServiceCategory?.display ? selectedServiceCategory?.display : selectedServiceCategory?.name
                    }
                  ],
                  text: `Appointment for ${selectedServiceCategory?.display ? selectedServiceCategory?.display : selectedServiceCategory?.name}`
                }
            ]
            
            /** if(values?.availableSlot?.status === "busy-reserved"){
                utcStart= values?.availableSlot?.start
                utcEnd = values?.availableSlot?.end
                slot = values?.availableSlot;
            }
            else **/ 
            if(formik?.values?.practitionerPreference === "no preference") {
                values.practitioner = values?.availableSlot?.actorId;
                values.scheduleId = values?.availableSlot?.scheduleId;
            }
            else values.scheduleId = values?.availableSlot?.scheduleId;
            
            const requestedPeriod = [{start: utcStart, end: utcEnd}]   
            let topic = buildSessionTopic(user?.name[0]?.text);
            
            let password= generatePass();   
            getSignature({ topic: topic.trim(), role: 0, password: password })
            .then(async (res) => {
                const sessionToken = res?.data?.sessionToken;
                let intakeQuestions = {}
                let patientLocation;
                    if(type === "patient"){
                        for (let element of taggedQuestions) {
                            if (element.tag == 'TELEPHONE') { 
                                intakeQuestions[element.text] =  element.answer[0].answer; 
                                intakeQuestions.callerNumber = values?.returnTelephoneNumber 
                                if (values?.returnTelephoneNumberExt) {
                                    intakeQuestions.callerNumberExt = values?.returnTelephoneNumberExt 
                                }
                            }
                            else if(element.tag == 'LOCATION') {
                                const selected = element.answer.find((val) => val.answer.length > 0);
                                intakeQuestions[element.text] = LOCATIONS[selected.answer];  
                                patientLocation = LOCATIONS[selected.answer]; 
                            }
                            else if(element.tag == "CALLER") { 
                                intakeQuestions[element.text] = (element?.answer?.[0]?.answer || "") +  ' ' +  (element?.answer?.[1]?.answer || "");
                                intakeQuestions.callerName = getValueQuestionnair("CALLER");
                            }
                            else if(element.tag == "SELFCALLING") {
                                if(getValueQuestionnairRadio("SELFCALLING") === "Yes"){ 
                                    intakeQuestions[element.text] = "Self"
                                    intakeQuestions.callerRelationship = "Self"
                                }  
                                else if(isTagPresent("RELATIONSHIP")) {
                                    intakeQuestions[element.text] = getValueQuestionnairDropDown("RELATIONSHIP");
                                    intakeQuestions.callerRelationship = getValueQuestionnairDropDown("RELATIONSHIP");
                                }
                            }
                            else if(element.tag !== "RELATIONSHIP") {
                                let value = null
                                if(element.answerType == "dropDown") {
                                    value = element.answer.find((val) => val.answer.length > 0);
                                    intakeQuestions[element.text] = value.answer;
                                }
                                else if(element.answerType == "radio") {
                                    value = element.answer?.filter((val) => val.answer);
                                    intakeQuestions[element.text]= value.length > 0 ? value[0].option : "" 
                                }
                                else {
                                    value = element.answer[0].answer;
                                    intakeQuestions[element.text]= value;
                                }
                            }
                        }
                        intakeQuestions["questionnaireResponseId"] = {reference: `QuestionnaireResponse/${questionnaireResponseId}`}
                        intakeQuestions["preferredChannel"] = values?.preferredChannel
                    }else{
                        intakeQuestions["callerNumber"] = values?.returnTelephoneNumber
                        intakeQuestions["callerNumberExt"] = values?.returnTelephoneNumberExt
                        intakeQuestions["preferredChannel"] = values?.preferredChannel
                    }

                bookAppointment({serviceCategory: serviceCategoryPayload, requestType: (formik?.values?.practitionerPreference == "no preference") ? "organization" : "provider", slot, sessionToken, practitionerId: type === "patient" ? values?.practitioner  : modalShow?.id, patientId: type === "patient" ? formikInBoundCall?.values?.patientId : JSON.parse(values?.patient)?.id, requestedPeriod, description: values?.title, scheduleId: values?.scheduleId, intakeQuestions, patientLocation:  patientLocation, newEncounterIdFromModal: encounterIdFromModal})
                  .then((res) => {
                      if (type === "patient") {
                        localStorage.removeItem("firstName")
                        localStorage.removeItem("lastName")
                    //   let updatePayload = {isHostJoined: true, sessionToken: sessionToken, id: res?.result?.id, status: "booked", patientId: res?.result?.patientId, practitionerId: res?.result?.practitionerId, proceedWith: formikInBoundCall?.values.howToProcced, questionnaireResponse}
                    let updatePayload = {isHostJoined: false, sessionToken: sessionToken, id: res?.result?.id, status: "booked", patientId: res?.result?.patientId, practitionerId: res?.result?.practitionerId, proceedWith: formikInBoundCall?.values.howToProcced, intakeQuestions, patientLocation: patientLocation}
                      updateAppointmentRequest(updatePayload)
                      .then((res) => {
                        if(res.status === true){
                            editQuestionnaireResponse(questionnaireResponseId, {encounterId: res?.result?.encounterId, authorName: user?.name[0]?.text, authorType: "Practitioner", authorId: user["custom:practitioner_id"] }).then((res)=>{
                                onHide()
                                handleShow();
                              }).catch((res) => failed(res?.response?.data?.message || res?.response?.data?.error || res.message))
                              .finally(() => setBtnLoading(false));
                        }
                      })
                      .catch((err) => failed(err?.response?.data?.message || err?.response?.data?.error ||  err?.message)
                      ).finally(() => setBtnLoading(false));
                    }
                    success("Appointment Scheduled");
                    onHide()
                    handleShow();
                  })
                  .catch((res) => failed( res?.response?.data?.message || res?.response?.data?.error || res.message))
                  .finally(() => setBtnLoading(false));
              })
              .catch((error) => console.log("getsignature error", { error }));
        },
    });

    useEffect(() => {
        // let startDate = (formik?.values?.date?.length > 0) ? moment(formik?.values?.date).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD");
        let startLocal = (formik?.values?.date?.length > 0) ? moment(formik?.values?.date) : moment();
        let startValue = startLocal.valueOf()
        let today = new Date();
        let startDate = startLocal.utc().format("YYYY-MM-DDTHH:mm:ss") + "Z";
        let start = startLocal.format("YYYY-MM-DD");
        // if (formik?.values?.date) {
        if(formik?.values?.practitionerPreference &&
             ((formik?.values?.practitionerPreference === "select practitioner" && practitionerId)
                || formik?.values?.practitionerPreference === "no preference" )) {
            checkSchedule({ actorId: formik?.values?.practitionerPreference === "no preference" ? user["custom:unique_id"] :  practitionerId, date: startDate, orgId: formik?.values?.practitionerPreference === "no preference" ? user?.organizations[0]?.id : null }) 
            .then((res) => { 
                    if(!res?.data) {
                        failed(res?.message);
                        setServiceCategory([]);
                        setCategoriesByDay({});
                        return;
                    }
                    
                    let categories = [];
                    if (!Array.isArray(res.data)) res.data = [res.data];

                    // remove any schedules from different organizations than the current user's 
                    res.data = res.data.filter(sch => sch.orgId == user?.organizations[0]?.id)
                    setFetchedSchedules(res.data);
                    let tempByDay = {};
                    res.data.forEach(schedule => {
                        schedule.serviceCategory.forEach(category => {
                            if(category.id) { // occasional bad data where there is a date and no id, so do not process
                                let key = moment(category?.date).format("YYYY-MM-DD");
                                let catTimestamp = moment(category?.date).valueOf();
                                if(moment(catTimestamp).isSameOrAfter(moment(startValue), "day") && 
                                    !categories.some(item => item.value === category.id)) {
                                    categories.push({...category, value: category?.id}); 
                                }
                                if(moment(catTimestamp).isSameOrAfter(moment(startValue), "day")) {
                                    if(tempByDay[key]) {
                                        if(!tempByDay[key].some(id => id === category.id )) 
                                            tempByDay[key].push(category.id)
                                    }
                                    else tempByDay[key] = [category.id];   
                                }
                            }
                        })                     
                    })
                    
                    setCategoriesByDay(merge(categoriesByDay, tempByDay)) 
                    let reservedSlots ={}
                    let newData = [];
                    res.data.forEach(schedule => 
                        getScheduleSlots(schedule.id, "busy-reserved", userOrgId)
                        .then((resp) => {
                            resp.data?.filter((slot)=> moment(slot?.start).isSameOrAfter(moment(start),"day"))
                            ?.map((slot) => {
                                slot.serviceCategory?.forEach(cat => {
                                    let serviceCategoryId = cat.id || cat.coding[0].code;
                                    if (reservedSlots.hasOwnProperty(serviceCategoryId)) {
                                        reservedSlots[serviceCategoryId].push({
                                            "start": slot?.start,
                                            "end": slot?.end,
                                            "scheduleId": slot?.scheduleId,
                                            "serviceCategory": [cat],
                                            "orgId": slot?.orgId,
                                            "actorId": schedule.actorId,
                                            "status": "busy-reserved"
                                        });
                                    }    
                                    else {
                                        reservedSlots[serviceCategoryId] = [{
                                            "start": slot?.start,
                                            "end": slot?.end,
                                            "scheduleId": slot?.scheduleId,
                                            "serviceCategory": [cat],
                                            "orgId": slot?.orgId,
                                            "actorId": schedule.actorId,
                                            "status": "busy-reserved"
                                        }];
                                    }
                                })
                            })
                            if(Array.isArray(reservedSlots))
                                if(moment(startLocal).isSame(moment(today), "day")) {
                                    reservedSlots = removeLateSlots(removePastSlots(reservedSlots), moment(startLocal).utc().format("YYYY-MM-DDTHH:mm:ss") + "Z");
                                }
                                else {
                                    reservedSlots = removeLateSlots(removeSlotsOutsideOfDayRange(removePastSlots(reservedSlots), moment(startLocal).utc()), moment(startLocal).utc())
                                }
                            else {
                                Object.keys(reservedSlots).forEach(key => {
                                if(moment(startLocal).isSame(moment(today), "day")) {
                                    reservedSlots[key] = removeLateSlots(removePastSlots(reservedSlots[key]), moment(startLocal).utc())
                                }
                                else {
                                    reservedSlots[key] = removeLateSlots(removeSlotsOutsideOfDayRange(removePastSlots(reservedSlots[key]), moment(startLocal).utc()), moment(startLocal).utc())
                                }
                            })
                            }
                            Object.keys(reservedSlots).forEach(key => {
                                if(reservedSlots[key].length > 0 
                                    && (reservedSlots[key][0]?.serviceCategory?.[0]?.id || reservedSlots[key][0]?.serviceCategory?.[0].coding[0]?.code)) {
                                    // && !newData.some(item => item.value === `${reservedSlots[key][0]?.serviceCategory?.[0]?.id}-busyReserved`)) {
                                    // console.log("RESERVED SLOT KEY", key)
                                    // newData.push({
                                    //     name: `Reserved for ${reservedSlots[key]?.[0]?.serviceCategory[0]?.name}`,
                                    //     value: `${reservedSlots[key][0]?.serviceCategory?.[0]?.id}-busyReserved`,
                                    //     status: "busy-reserved"
                                    // });
                                    if(moment(reservedSlots[key][0]?.start).isSameOrAfter(startValue, "day") && 
                                    !categories.some(item => item.value === key)) {
                                        let timeSlot = reservedSlots[key][0]?.serviceCategory?.[0]?.timeSlot;
                                        if(!timeSlot) {
                                            // slot is in a different format, so you need to parse the description to get the timeslot.
                                            let timeSlotString = reservedSlots[key]?.[0]?.serviceCategory[0]?.coding[0]?.display.split("(")[1].split(")")[0].split(" ");
                                            // this should be an array of number and unit now.
                                            timeSlot = { 
                                                value: parseInt(timeSlotString[0]),
                                                unit: 'minutes'
                                            };
                                        }
                                        let name = (reservedSlots[key]?.[0]?.serviceCategory[0]?.name || reservedSlots[key]?.[0]?.serviceCategory[0]?.coding[0]?.display);
                                        let value = (reservedSlots[key][0]?.serviceCategory?.[0]?.id || reservedSlots[key][0]?.serviceCategory?.[0].coding[0]?.code);
                                        categories.push({
                                            name, 
                                            value,
                                            timeSlot,
                                            orgId: reservedSlots[key][0].orgId,
                                            date: reservedSlots[key][0]?.start
                                        })
                                    }
                                    // ADD TO CATEGORIES BY DAY HERE
                                    tempByDay = {};
                                    if(reservedSlots[key].length > 0) {
                                        reservedSlots[key].forEach(slot => {
                                            let datekey = moment(slot?.start).format("YYYY-MM-DD");
                                            let startTimestamp  = moment(slot?.start).valueOf();
                                            console.log(moment(startTimestamp).isSameOrAfter(moment(startValue), "day"))
                                            if(moment(startTimestamp).isSameOrAfter(moment(startValue), "day")) {
                                                if(tempByDay[datekey] && !tempByDay[datekey]?.some(id => id === key)) {
                                                        tempByDay[datekey].push(key);
                                                }
                                                else tempByDay[datekey] = [key];
                                            }
                                        })
                                    }
                                    setCategoriesByDay(merge(categoriesByDay, tempByDay)) 
                                }
                            });                             
                            setReservedCategories(reservedSlots);
                            setServiceCategory([...categories]) //, ...newData])                            
                        })
                        .catch((res) => {
                            failed(res?.response?.data?.message || res?.response?.data?.error || res.message);
                            setServiceCategory([]);
                            setCategoriesByDay({});
                        })
                    );
                })
                .catch((res) => {
                    failed(res?.response?.data?.message || res?.response?.data?.error || res.message);
                    setServiceCategory([]);
                    setCategoriesByDay({});
                });
            }
    }, [modalShow?.id, formik?.values?.practitioner, formik?.values?.practitionerPreference])


    const handlePatientChange = (event) => {
        formik.setFieldValue("patient", event?.target?.value);
        setScopeOfPractice(JSON.parse(event?.target?.value)?.location); 
    };

    /** removes any slot that has a start time before this instant */
    const removePastSlots = (slots) => {
        let now = new Date().getTime();
        return slots?.filter(slot => new Date(slot.start).getTime() > now);
    }

    /** sorts slots based on time */
    const sortedSlots = (data) => {      
        return data?.sort((a,b) => {
            let atime = (moment(a.start).isValid()) ? `${a.start}`:`${moment(formik.values.date)?.format("YYYY-MM-DD")}T${a?.start}:00Z`;
            let btime = (moment(b.start).isValid()) ? `${b.start}`:`${moment(formik.values.date)?.format("YYYY-MM-DD")}T${b?.start}:00Z`;
            return (new Date(atime).getTime() < new Date(btime).getTime()) ? -1 : 1;            
        })
    }
    /** sorts any object based on a name attribute */
    const sortedObj = data => {
        return data.sort((a,b) => {
            return a.name > b.name ? 1 : -1
        });
    }

    /***
     * merge is used to merge 2 objects.  Previously used Object.assign and it would
     * cause data lose, so this is a better method for the categories by day which
     * modifies the obj1 with data from obj2.
     */
    const merge = (obj1, obj2) => {
        for(let key in obj2) {
            if(obj1[key]) {
                // if both elements contain an array, then extend the array
                if(Array.isArray(obj1[key]) && Array.isArray(obj2[key])) {
                    obj2[key].forEach(cat => {
                        if(!obj1[key].includes[cat])
                            obj1[key].push(cat);
                    })
                }
                else {
                    // else replace the value with matching obj2
                    obj1[key] = obj2[key]
                }
            }
            else 
                obj1[key] = obj2[key];
        }
        return obj1;
    }

    const findUpcoming = (event) => {
        setSlotUnavailable(false);        
        let targetVal = event?.target?.value;
        formik.setFieldValue("serviceCategory", targetVal);
        setAvailableSlots([])
        formik.setFieldValue("date", "");
    }

    const renderDay = (props) => {
        const { selectedDate, day, dayComponent, ...other} = props;
        const today = moment();
        const isAvailable = availableDays.includes(day.format("YYYY-MM-DD"));
        const isSelected = day.isSame(selectedDate, "day");
        const isToday = day.isSame(today, "day");
        const isPast = day.isBefore(today, "day")

        return (
            <PickersDay {...dayComponent} 
                disabled={isPast || !isAvailable}
                style={isAvailable ? {background: "#accfeb"}: {background: "white" }} />
        );
    }

    /**
     * Loads available slots for a given date and appointment type.
     * Handles reserved slots, merges with available slots, and sorts them.
     */
    const loadSlotData = (selectedDate, selectedType) => {
        setSlotsLoading(true);
        setSlotUnavailable(false);

        const today = moment();
        const date = moment(selectedDate || formik?.values?.date);
        const type = selectedType || formik?.values?.serviceCategory;
        const dateUtc = date.utc().format("YYYY-MM-DDTHH:mm:ss") + "Z";

        if (!type) {
            setSlotsLoading(false);
            return;
        }

        // Get reserved slots for this type
        let reservedSlots = reservedCategories[type] || [];
        reservedSlots = reservedSlots
            .filter(slot => moment(slot.start).isAfter(date) && moment(slot.start).isSame(date, "day"));
        reservedSlots = sortedSlots(reservedSlots);

        // Prepare params for fetching available slots
        const params = {
            actorId: practitionerId || modalShow?.id || user["custom:unique_id"],
            date: dateUtc,
            serviceCategoryId: type,
            orgId: formik?.values?.practitionerPreference === "no preference"
                ? user?.organizations[0]?.id
                : userOrgId
        };

        // Add scopeOfPractice if needed
        if (formik?.values?.practitionerPreference === "no preference") {
            if (scopeOfPractice) {
                params.scopeOfPractice = scopeOfPractice;
            } else if (taggedQuestions) {
                const locationTag = taggedQuestions.find(el => el.tag === "LOCATION");
                if (locationTag) {
                    const selected = locationTag.answer.find(val => val.answer.length > 0);
                    if (selected) {
                        const tempScope = LOCATIONS[selected.answer];
                        setScopeOfPractice(tempScope);
                        params.scopeOfPractice = tempScope;
                    }
                }
            }
        }

        getSlots(params)
            .then(res => {
                let available = res?.data?.availableSlots || [];
                // Remove past/late slots
                if (date.isSame(today, "day")) {
                    available = removeLateSlots(removePastSlots(available), dateUtc);
                } else {
                    available = removeLateSlots(removeSlotsOutsideOfDayRange(available, date.utc()), date.utc());
                }
                available = sortedSlots(available);

                // Merge reserved slots, avoiding duplicates
                reservedSlots.forEach(slot => {
                    if (!available.some(item => item.start === slot.start)) {
                        available.push(slot);
                    }
                });

                available = sortedSlots(available);
                setAvailableSlots(available);

                if (available.length < 1) {
                    setSlotUnavailable(true);
                }
            })
            .catch(err => {
                if (reservedSlots.length > 0) {
                    setAvailableSlots(reservedSlots);
                } else {
                    failed(err?.response?.data?.message || err?.response?.data?.error || err?.message);
                    setAvailableSlots([]);
                }
            })
            .finally(() => setSlotsLoading(false));
    };

    const removeLateSlots = (slots, date) => {
        let midnight = (date) ? new Date(date) : new Date();
        // console.log("DATE", midnight) // date before processing
        midnight = new Date(midnight.setDate(midnight.getDate()+1));
        midnight.setHours(0)
        midnight.setMinutes(0)
        midnight.setSeconds(0);
        // console.log("REMOVE LATE SLOTS MIDNIGHT: ", midnight); // midnight of submitted date.
        if(Array.isArray(slots)) {
            // console.log("slot count", slots.length)
            const filteredSlots = slots.filter(slot => {
                // console.log("SLOT END", slot.end)
                let endTime = new Date(slot.end).getTime();
                let midnightTime = midnight.getTime();
                // console.log(endTime < midnightTime, slot.start)
                return (endTime < midnightTime)
            })
            // console.log("slot count after filter", filteredSlots.length)
            //setOrgSlotsData(filteredSlots);
            return filteredSlots;
        }
        else return slots;        
    }

    function removeSlotsOutsideOfDayRange(slots, date) {
        let midnight = (date) ? new Date(date) : new Date();
        midnight = new Date(midnight.setDate(midnight.getDate()));
        midnight.setHours(0)
        midnight.setMinutes(0)
        midnight.setSeconds(0);
        // console.log("REMOVE OUTSIDE DAY RANGE MIDNIGHT: ", midnight); // start of submitted day, localtime.
        if(Array.isArray(slots)) {
            // console.log("slot count", slots.length)
            const filteredSlots = slots.filter(slot => {
                // console.log("SLOT START", slot.start)
                let startTime = new Date(slot.start).getTime();
                let midnightTime = midnight.getTime();
                // console.log(startTime > midnightTime, slot.start)
                return (startTime > midnightTime)
            })
            // console.log("slot count after filter", filteredSlots.length)
            //setOrgSlotsData(filteredSlots);
            return filteredSlots;
        }
        else return slots;
    }

    const handleDateSelection = (val) => {
        const isValidDate = moment(val, 'MMM-DD-YYYY').isValid()
        setAvailableSlots([])
        if(type === "patient"){
            if(formik.values.practitionerPreference == ''){
                failed('Please select practitioner preference')
            }else{
                if(isValidDate){
                    formik.setFieldValue("date", val.format("YYYY-MM-DD"));
                    // load slots here
                    loadSlotData(val.format("YYYY-MM-DD"))
                }else{
                    formik.setFieldError('date', 'Invalid date format')
                }
            }
        }else{
            if(isValidDate){
                formik.setFieldValue("date", val.format("YYYY-MM-DD"));
                loadSlotData(val.format("YYYY-MM-DD"))
            }else{
                formik.setFieldError('date', 'Invalid date format')
            }
        }       
    }

    useEffect(() => {
        let scope = LOCATIONS[taggedQuestions?.filter(el => el.tag === "LOCATION")[0].answer.find((val) => val.answer.length > 0).answer]; // get the scope of practice from the intake questions.
        getlistPractitioners({orgId: user?.organizations[0]?.id , scopeOfPractice: scope })
          .then(async (res) => {
            let allPracts = res.result?.filter(pra => pra.active);
            let activePractitioners = [];
            let startDate = (formik?.values?.date?.length > 0) ? moment(formik?.values?.date) : moment();
            startDate = moment(startDate).utc().format("YYYY-MM-DDTHH:mm:ss") + "Z";
            
            await checkSchedule({actorId: user["custom:unique_id"], date: startDate, orgId: user?.organizations[0]?.id })
            .then((activeSchedules)=> {
                if(!activeSchedules?.data) { 
                    // no active schedules, so list no practitioners
                    failed(activeSchedules?.message);
                    setServiceCategory([]);
                    setCategoriesByDay({});
                    setPractitionerList([]);
                    return;
                }
                if(!Array.isArray(activeSchedules.data)) 
                    activeSchedules.data = [activeSchedules.data];

                // remove empty schedules
                activeSchedules.data = activeSchedules.data.filter(sch => {
                    return sch.orgId === user?.organizations[0]?.id 
                        && sch.serviceCategory?.length > 0 
                        && sch.serviceCategory.filter(cat => moment(cat.date).isSameOrAfter(moment(startDate), "day")).length > 0
                })
                
                activeSchedules.data.forEach(schedule => {
                    let active = allPracts.find(person => person.id === schedule.actorId && !activePractitioners.some(exists => exists.id === schedule.actorId))
                    if(active) 
                        activePractitioners.push(active);
                })
                // practitioners that have active schedules for the current month.
                setPractitionerList(activePractitioners.map(ele => (
                    { 
                        value: ele?.id, 
                        name: ele?.name?.[0]?.text?.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' '), // capitalize all names, surname, given name, etc.
                        id: ele?.id 
                    }
                ))) 
            })                
            .catch((activeSchedules) => {
                failed(activeSchedules?.response?.data?.message || activeSchedules?.response?.data?.error || activeSchedules.message);
                setServiceCategory([]);
                setCategoriesByDay({});
                setPractitionerList([]);
            });            
          })
          .catch((res) => {
            console.log("error fetching practioner list",res)
          })
      }, []);

    const handlePractitionerChange = (event) => {
        setPractitionerId(event?.target?.value)
        formik.setFieldValue("practitioner", formik?.values?.practitionerPreference === "no preference" ? "" : event?.target?.value);
        formik.setFieldValue("serviceCategory", ""); 
        formik.setFieldValue("date", "");
        setServiceCategory([]);
        setAvailableSlots([]);
        setCategoriesByDay([]);
    };

    const handlePractitionerPreferenceChange = (e) => {
        setPractitionerId(null); 

        formik.setFieldValue("practitioner", "");
        formik.setFieldValue("serviceCategory", ""); 
        formik.setFieldValue("date", "");
        setServiceCategory([]);
        setAvailableSlots([]);        
        setCategoriesByDay([]);
        formik.setFieldValue("practitionerPreference", e.target.id);
    };
    

    let isReadOnly = true

    useEffect(() => {
        if(type === "patient"){
            formik.setFieldValue("title", isTagPresent("REASON") ?  getValueQuestionnair("REASON") : "");
            formik.setFieldValue("patient", decryptData(formikInBoundCall?.values?.patientName));
            formik.setFieldValue("returnTelephoneNumber", isTagPresent("TELEPHONE") ?  formikInBoundCall?.values?.questionResponse?.find(item => item.tag === "TELEPHONE")?.answer?.[0]?.answer.split(" ext")[0] : "");
            formik.setFieldValue("returnTelephoneNumberExt" , isTagPresent("TELEPHONE")? getValueQuestionnairExt("TELEPHONE") : "");
        }

        return ()=> {
            let nameAnswer;
            const nameQuestion = formikInBoundCall?.values?.questionResponse.find(question => question.tag === "CALLER");
            if (nameQuestion) {
                 nameAnswer = nameQuestion?.answer;
                  nameAnswer[0].answer = localStorage.getItem("firstName")
                  if(nameQuestion?.answer?.[1] === undefined) nameAnswer.push({answer: localStorage.getItem("lastName")}) 
                  nameAnswer[0].required = true;
                  nameAnswer[0].option = null;
                  nameAnswer[0].value = null;
                  nameAnswer[0].name = null;
            }
            formikInBoundCall?.setFieldValue("questionResponse", formikInBoundCall?.values?.questionResponse)
        }
      }, []);


    const highLightDates = () => {
        setAvailableDays([]);
        const today = moment();
        const now = moment();
        const toHighlight = [];

        const foundCategory = serviceCategory.find(
            (item) => item.id === formik.values.serviceCategory
        );

        if (!foundCategory || !foundCategory.timeSlot) {
            setAvailableDays([]);
            return;
        }

        const timeSlot = parseInt(foundCategory.timeSlot.value, 10);
        const availabilities = computedServiceCategories?.[formik.values.serviceCategory] || [];

        availabilities.forEach((period) => {
            let periodStart = moment(period.start);
            let periodEnd = moment(period.end);

            // Only consider today or future days
            if (periodStart.isBefore(today, "day")) return;

            // Adjust current period if it’s today
            if (periodStart.isSame(today, "day")) {
            if (periodEnd.isBefore(now)) return;
            if (periodStart.isBefore(now)) periodStart = now.clone();
            }

            const availableMinutes = periodEnd.diff(periodStart, "minutes");
            if (availableMinutes >= timeSlot) {
            const dayKey = periodStart.format("YYYY-MM-DD");
            if (!toHighlight.includes(dayKey)) {
                toHighlight.push(dayKey);
            }
            }
        });

        setAvailableDays(toHighlight);
    };


    const fetchSchedules = async () => {
        const schedulesWithSlots = await Promise.all(
            fetchedSchedules.map(async (schedule) => {
            const slotsResponse = await getScheduleSlots(schedule.id);
            const slots = slotsResponse.data || [];
            return { ...schedule, slots };
            })
        );

        const result = computeServiceCategoryAvailabilities(schedulesWithSlots);
        setComputedServiceCategories(result);
    };


    const computeServiceCategoryAvailabilities = (schedules) => {
        const busyStatuses = [
            "busy-meeting", "busy-unavailable", "busy-training", "busy-documentation",
            "busy-meal", "busy-administration", "busy-unscheduled", "busy-break", "busy-other",
        ];

        // Removes a busy period from available blocks
        const subtractTimePeriod = (availabilityPeriods, slotStart, slotEnd) => {
            const updated = [];

            for (const period of availabilityPeriods) {
            if (slotEnd <= period.start || slotStart >= period.end) {
                updated.push(period); // no overlap
            } else {
                if (slotStart > period.start) {
                updated.push({ start: period.start, end: slotStart }); // before busy time
                }
                if (slotEnd < period.end) {
                updated.push({ start: slotEnd, end: period.end }); // after busy time
                }
            }
            }

            return updated;
        };

        // Adds a new reserved time block
        const insertTimePeriod = (availabilityPeriods, slotStart, slotEnd) => {
            return [...availabilityPeriods, { start: slotStart, end: slotEnd }];
        };

        // Merges overlapping or adjacent time blocks
        const mergeTimePeriods = (periods) => {
            if (!periods.length) return [];

            periods.sort((a, b) => a.start - b.start);
            const merged = [periods[0]];

            for (let i = 1; i < periods.length; i++) {
            const last = merged[merged.length - 1];
            const current = periods[i];

            if (current.start <= last.end) {
                last.end = new Date(Math.max(last.end, current.end)); // merge
            } else {
                merged.push(current);
            }
            }

            return merged;
        };

        const serviceCategoryAvailabilities = {};
        const allServiceCategories = {};

        for (const schedule of schedules) {
            const planningStart = new Date(schedule.planningHorizon.start);
            const planningEnd = new Date(schedule.planningHorizon.end);

            // Step 1: Add initial availability per service category
            for (const sc of schedule.serviceCategory || []) {
            const scId = sc.id;
            const scName = sc.name;
            const scDate = new Date(sc.date);

            const y = scDate.getFullYear();
            const m = scDate.getMonth();
            const d = scDate.getDate();

            const dayStart = new Date(y, m, d, planningStart.getHours(), planningStart.getMinutes());
            const dayEnd = new Date(y, m, d, planningEnd.getHours(), planningEnd.getMinutes());

            // Clamp dayStart and dayEnd within planning horizon
            if (dayStart < planningStart && planningStart.toDateString() === dayStart.toDateString()) {
                dayStart.setHours(planningStart.getHours(), planningStart.getMinutes());
            }
            if (dayEnd > planningEnd && planningEnd.toDateString() === dayEnd.toDateString()) {
                dayEnd.setHours(planningEnd.getHours(), planningEnd.getMinutes());
            }

            if (dayStart >= dayEnd) continue;

            if (!allServiceCategories[scId]) {
                allServiceCategories[scId] = { id: scId, name: scName };
            }

            if (!serviceCategoryAvailabilities[scId]) {
                serviceCategoryAvailabilities[scId] = [];
            }

            serviceCategoryAvailabilities[scId].push({ start: dayStart, end: dayEnd });
            }

            // Step 2: Apply slots to subtract or insert busy times
            for (const slot of schedule.slots || []) {
            const slotStart = new Date(slot.start);
            const slotEnd = new Date(slot.end);
            const slotStatus = slot.status;
            const slotServiceCategories = slot.serviceCategory || [];

            const scTypes = slotServiceCategories.map((item) =>
                item?.id
                ? { id: item.id, name: item.name }
                : { id: item?.coding?.[0]?.code, name: item?.coding?.[0]?.display }
            );

            if (slotStatus === "busy-reserved") {
                // Reserved time should be removed from *other* categories
                for (const scId in serviceCategoryAvailabilities) {
                if (!scTypes.find((s) => s.id === scId)) {
                    serviceCategoryAvailabilities[scId] = subtractTimePeriod(
                    serviceCategoryAvailabilities[scId],
                    slotStart,
                    slotEnd
                    );
                }
                }

                // But added to the reserved category
                for (const sc of scTypes) {
                allServiceCategories[sc.id] = allServiceCategories[sc.id] || sc;
                serviceCategoryAvailabilities[sc.id] = insertTimePeriod(
                    serviceCategoryAvailabilities[sc.id] || [],
                    slotStart,
                    slotEnd
                );
                }
            } else if (busyStatuses.includes(slotStatus)) {
                // Generic busy time blocks availability for all categories
                for (const scId in serviceCategoryAvailabilities) {
                serviceCategoryAvailabilities[scId] = subtractTimePeriod(
                    serviceCategoryAvailabilities[scId],
                    slotStart,
                    slotEnd
                );
                }
            }
            }
        }

        // Step 3: Merge overlapping time periods per category
        for (const scId in serviceCategoryAvailabilities) {
            serviceCategoryAvailabilities[scId] = mergeTimePeriods(serviceCategoryAvailabilities[scId]);
        }

        return serviceCategoryAvailabilities;
    };

    useEffect(() => {
        if(fetchedSchedules.length > 0 && formik?.values?.practitionerPreference) {
            fetchSchedules()
        }
    }, [fetchedSchedules, formik?.values?.practitionerPreference]);
    
    return (
        <Modal
            backdropClassName
            backdrop={'static'}
            size="xl" show={modalShow} onHide={onHide}
            aria-labelledby="contained-modal-title-vcenter"
            centered className="custom-dialog">
            <Modal.Header closeButton className="border-0">
                <Modal.Title id="contained-modal-title-vcenter">
                    Create Appointment for <span style={{ textTransform: "capitalize" }}>{modalShow?.name?.[0]?.text||formikInBoundCall?.values?.patientName}</span>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form className="common-form border-fields" onSubmit={formik.handleSubmit}>
                    {isLoading ? (
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "50vh",
                            }}
                        >
                            <CircularProgress />
                        </div>
                    ) : (
                        <>
                            <Row>
                                <Col>
                                    <TextInput keyField={"title"} label={"Reason for visit"} formik={formik} placeholder={"Reason for visit"} />
                                </Col>
                                <Col>
                                    {!type ? (<SelectFiled keyField={"patient"} label={"Patient Name"} formik={formik} options={patientsList}  onChange={handlePatientChange} />)
                                    : (<TextInput keyField={"patient"} label={"Patient Name"} formik={formik} disabled={true} placeholder={"Patient Name"} style={{textTransform: "capitalize"}} />)}
                                </Col>
                            </Row>
                            {type === "patient" ? 
                            <Row>
                                <Col>
                                    <Form.Check.Label style={{ textTransform: "capitalize", fontSize: "14px" }} >{"practitioner preference ?"}</Form.Check.Label> <span className="requiredField">&#42;</span><br/>
                                    {["select practitioner", "no preference"].map((val) => (
                                        <Form.Check style={{ textTransform: "capitalize", fontSize: "14px", marginRight: "45px"}} inline checked={formik.values.practitionerPreference === val} type={"radio"} label={val} id={val} name="practitioner preference"  onChange={handlePractitionerPreferenceChange} />
                                     ))}
                                     {formik?.touched["practitionerPreference"] && formik?.errors["practitionerPreference"] ? (<div className="error-text">{formik?.errors["practitionerPreference"]} </div>) : null}
                                </Col>
                                {formik?.values?.practitionerPreference === "select practitioner" ? (
                                    <Col>
                                        <SelectFiled keyField={"practitioner"} label={"Select Practitioner"} formik={formik} options={sortedObj(practitionerList)} isReadOnly={isReadOnly} onChange={handlePractitionerChange} />
                                    </Col>
                                ) : <Col></Col>}
                                
                            </Row> : null}
                            <Row className="mt-3">
                                <Col>
                                    <SelectFiled keyField={"serviceCategory"} label={"Appointment Type"} formik={formik} options={sortedObj(serviceCategory)} disabled={!formik.values.practitionerPreference} onChange={findUpcoming} />
                                </Col>
                                <Col>
                                    <DateSelectorWithoutFormik disabled={!formik?.values?.serviceCategory} formik={formik} keyField={'date'} label="Date" value={(formik?.values?.date?.length > 0) ? moment(formik?.values?.date) : null} handleChange={(value) => { handleDateSelection(value)}} minDate={moment()} defaultValue={moment()} onMonthChange={highLightDates} onOpen={highLightDates} renderDay={(day, selectedDate, dayComponent) => renderDay({day, selectedDate, dayComponent})} />
                                </Col>
                            </Row>
                            {availableSlots?.length > 0 ?
                                <>
                                    <Row>
                                        <Col>Select Slot</Col>
                                    </Row>
                                    <Row style={{ rowGap: "0.5rem", marginBottom: "1.5rem", marginTop: "0.5rem" }}>
                                        {availableSlots?.map((slot, index) => {
                                        let localTime = moment(slot?.start).format("HH:mm");
                                        
                                        return ( <Col style={{ background: selectedSlot === slot?.start ? "#6c757d38" : "#ffff", width: "14.666667%" }} sm={2} className="slotStyle" key={index} onClick={() => { formik?.setFieldValue("availableSlot", slot); setSelectedSlot(slot?.start) }}>{localTime}</Col>)
                                        })}
                                    </Row>
                                </>
                                : <div className="error-text" style={{marginBottom: "1.5rem", display: slotUnavailable ?  "block" : "none" }}>
                                No Available Slots
                             </div>}
                                
                                {slotsLoading ?
                                <>
                                    <Row>
                                        <Col>Select Slot</Col>
                                    </Row>
                                    <Skeleton height={50} />
                                </>
                                : null}
                            <Row>
                                <Col>
                                    <Form.Check.Label style={{ textTransform: "capitalize", fontSize: "14px" }} >{"preferred channel ?"}</Form.Check.Label> <span className="requiredField">&#42;</span><br/>
                                    {["phone", "video/chat"].map((val) => (
                                        <Form.Check style={{ textTransform: "capitalize", fontSize: "14px", marginRight: "65px"}} inline checked={formik.values.preferredChannel === val} type={"radio"} label={val} id={val} name="preferred channel"  onChange={e => formik.setFieldValue("preferredChannel", e.target.id)} />
                                     ))}
                                     {formik?.touched["preferredChannel"] && formik?.errors["preferredChannel"] ? (<div className="error-text">{formik?.errors["preferredChannel"]} </div>) : null}
                                </Col>
                                {type === "patient" ? (isTagPresent("TELEPHONE")) ? (
                                <>
                                <Col>
                                    <Row>
                                        <Col>
                                            <TextInput keyField={"returnTelephoneNumber"} type="phone" label={"Return Telephone Number"} formik={formik} disabled={type === "patient" ? isTagPresent("TELEPHONE") ? true : false : false} placeholder={"Return Telephone Number"} required={true} />
                                        </Col>
                                        <Col>
                                            <TextInput keyField={"returnTelephoneNumberExt"} label={"Ext."} formik={formik} disabled={type === "patient" ? isTagPresent("TELEPHONE") ? true : false : false} placeholder={"Ext."} required={false} />
                                        </Col>
                                    </Row>
                                </Col>
                            </>) :  null :
                                <>
                                        <Col>
                                            <Row>
                                                <Col>
                                                    <TextInput keyField={"returnTelephoneNumber"} type="phone" label={"Return Telephone Number"} formik={formik} disabled={type === "patient" ? isTagPresent("TELEPHONE") ? true : false : false} placeholder={"Return Telephone Number"} required={true} />
                                                </Col>
                                                <Col>
                                                    <TextInput keyField={"returnTelephoneNumberExt"} label={"Ext."} formik={formik} disabled={type === "patient" ? isTagPresent("TELEPHONE") ? true : false : false} placeholder={"Ext."} required={false} />
                                                </Col>
                                            </Row>
                                        </Col>

                                    </>
                                }
                            </Row>
                            
                            <Row></Row>
                            <Row>
                                {/* <Col>
                                    <TextArea keyField={"description"} label={"Description"} formik={formik} placeholder={"Description"} />
                                </Col> */}
                            </Row>
                        </>
                    )}
                    <div className="btn-wrap">
                        <Button
                            onClick={() => {
                                onHide();
                            }}
                            variant="secondary"
                            title="Cancel"
                        >
                            Cancel
                        </Button>
                        <Button type="submit" isLoading={btnLoading}>
                            Create
                        </Button>
                    </div>
                </form>
            </Modal.Body>
        </Modal>
    );
};

export default BookAppointment;
